import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Pencil } from 'lucide-react';
import { axios, auth, mbUrl, BRANCH_LABEL, runCall } from './mbApi';
import { FIELDS, DeadlinePicker } from './BriefForm';

const fromWorkflow = (w) => ({
  title: w.title || '', branch: w.branch || 'ai_self', deadline: w.deadline || '', brief: w.brief || '',
  refs: (w.reference_links || []).join('\n'), videos: (w.video_links || []).join('\n'), ...Object.fromEntries(FIELDS.map(([k]) => [k, w[k] || ''])),
});

export const EditBriefDialog = ({ ibId, w, reload }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(fromWorkflow(w));
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const save = () => runCall(setBusy, async () => {
    const { refs, videos, ...rest } = form;
    const split = (t) => t.split(/[\n,]/).map((x) => x.trim()).filter(Boolean);
    await axios.put(mbUrl(ibId, `/workflows/${w.id}`), { ...rest, reference_links: split(refs), video_links: split(videos) }, auth());
    setOpen(false);
    reload();
  }, 'Brief updated');

  return (
    <>
      <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => { setForm(fromWorkflow(w)); setOpen(true); }} data-testid={`mb-edit-brief-${w.id}`}>
        <Pencil size={12} className="mr-1" /> Edit Brief
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="mb-edit-brief-dialog">
          <DialogHeader><DialogTitle>Edit Brief</DialogTitle></DialogHeader>
          <div className="space-y-2">
            <Input value={form.title} onChange={(e) => set('title', e.target.value)} placeholder="Tajuk brief" data-testid="mb-edit-title" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <Select value={form.branch} onValueChange={(v) => set('branch', v)}>
                <SelectTrigger data-testid="mb-edit-branch"><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(BRANCH_LABEL).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
              </Select>
              <DeadlinePicker value={form.deadline} onChange={(v) => set('deadline', v)} />
            </div>
            {FIELDS.map(([k, label]) => (
              <Input key={k} value={form[k]} onChange={(e) => set(k, e.target.value)} placeholder={label} data-testid={`mb-edit-${k}`} />
            ))}
            <Textarea rows={2} value={form.refs} onChange={(e) => set('refs', e.target.value)} placeholder="Link rujukan (satu baris satu)" data-testid="mb-edit-refs" />
            <Textarea rows={2} value={form.videos} onChange={(e) => set('videos', e.target.value)} placeholder="Link video rujukan (satu baris satu)" data-testid="mb-edit-videos" />
            <Textarea rows={2} value={form.brief} onChange={(e) => set('brief', e.target.value)} placeholder="Nota" data-testid="mb-edit-notes" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="mb-edit-cancel">Cancel</Button>
            <Button onClick={save} disabled={busy || !form.title.trim()} data-testid="mb-edit-save">Save</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
